/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CommitteeSettingsDto,
  ProblemDetails,
  SaveCommitteeSettingsCommand,
  ValidationProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const getApiV1CommitteeSettings = (
    
 signal?: AbortSignal
) => {
      
      
      return request<CommitteeSettingsDto>(
      {url: `/api/v1/committee/settings`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1CommitteeSettingsQueryKey = () => {
    return [
    `/api/v1/committee/settings`
    ] as const;
    }

    
export const getGetApiV1CommitteeSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1CommitteeSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>> = ({ signal }) => getApiV1CommitteeSettings(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1CommitteeSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>>
export type GetApiV1CommitteeSettingsQueryError = ProblemDetails


export function useGetApiV1CommitteeSettings<TData = Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CommitteeSettings>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CommitteeSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CommitteeSettings<TData = Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CommitteeSettings>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CommitteeSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CommitteeSettings<TData = Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1CommitteeSettings<TData = Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CommitteeSettings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1CommitteeSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiV1CommitteeSettings = (
    saveCommitteeSettingsCommand: SaveCommitteeSettingsCommand,
 ) => {
      
      
      return request<void>(
      {url: `/api/v1/committee/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveCommitteeSettingsCommand
    },
      );
    }
  


export const getPutApiV1CommitteeSettingsMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1CommitteeSettings>>, TError,{data: SaveCommitteeSettingsCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1CommitteeSettings>>, TError,{data: SaveCommitteeSettingsCommand}, TContext> => {

const mutationKey = ['putApiV1CommitteeSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1CommitteeSettings>>, {data: SaveCommitteeSettingsCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiV1CommitteeSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1CommitteeSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1CommitteeSettings>>>
    export type PutApiV1CommitteeSettingsMutationBody = SaveCommitteeSettingsCommand
    export type PutApiV1CommitteeSettingsMutationError = ValidationProblemDetails | ProblemDetails

    export const usePutApiV1CommitteeSettings = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1CommitteeSettings>>, TError,{data: SaveCommitteeSettingsCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1CommitteeSettings>>,
        TError,
        {data: SaveCommitteeSettingsCommand},
        TContext
      > => {

      const mutationOptions = getPutApiV1CommitteeSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    